import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/producer/importer/producerImporterActions';

export default importerReducers(actions);
